import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { InsurerProgressItem } from "src/app/share/constants/quotation-progress";

// Header-only card for an insurer that couldn't quote this vehicle
@Component({
  selector: "app-unavailable-insurer-card",
  templateUrl: "./unavailable-insurer-card.component.html",
  styleUrls: ["./unavailable-insurer-card.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnavailableInsurerCardComponent {
  @Input() item: InsurerProgressItem;
}
